import { v4 as uuidv4 } from 'uuid';
import { APP_CLIENT_ID_KEY } from '../constants';

/**
 * Stable per-device client id for bet payloads (TP-3863): generated
 * once on first open, persisted in localStorage, reused ever after.
 * Clearing storage / incognito yields a new one — acceptable. NOT to
 * be confused with `clientBetId`, which must stay unique per bet.
 *
 * Falls back to a per-session in-memory id where storage is
 * unavailable (Safari private mode throws on setItem, node in tests
 * has no localStorage at all) — the id is then stable for the session
 * even though it cannot survive a reload.
 */
let memoryClientId: string | null = null;

export function getStableClientId(): string {
  if (memoryClientId) return memoryClientId;
  try {
    const stored = localStorage.getItem(APP_CLIENT_ID_KEY);
    if (stored) {
      memoryClientId = stored;
      return stored;
    }
    const fresh = uuidv4();
    localStorage.setItem(APP_CLIENT_ID_KEY, fresh);
    memoryClientId = fresh;
    return fresh;
  } catch {
    memoryClientId = uuidv4();
    return memoryClientId;
  }
}
